var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _g, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgDesktop(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 798,
    height: 602,
    viewBox: "0 0 798 602",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_75_11376)"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.49,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M140.789 161.424H584.767V493.421H140.789V161.424Z",
    fill: "#7D8FA4"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M133.844 154.504H590.667V493.42H133.844V154.504Z",
    stroke: "white",
    strokeWidth: 13.1379,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.703H2041.3V-109.932H-39V847.703Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_75_11376)"
  }, _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M43.8359 493.42H756.042",
    stroke: "white",
    strokeWidth: 19.7069,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.705H2041.3V-109.93H-39V847.705Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_75_11376)"
  }, _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M753.224 163.094L489.863 360.48",
    stroke: "#F8EC30",
    strokeWidth: 5.90962,
    strokeLinejoin: "round",
    strokeDasharray: "8.14 8.14"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M486.908 351.606L478.035 369.343L497.547 365.803L486.908 351.606Z",
    fill: "#F8EC30"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask2_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.705H2041.3V-109.93H-39V847.705Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask2_75_11376)"
  }, _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M582.238 246.642H601.945V386.779H582.238V246.642Z",
    fill: "#17375E"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask3_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.706H2041.3V-109.929H-39V847.706Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask3_75_11376)"
  }, _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M360.281 380.316H537.293",
    stroke: "white",
    strokeWidth: 5.90962,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask4_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.706H2041.3V-109.929H-39V847.706Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask4_75_11376)"
  }, _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.26,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M370.055 384.101H522.492V488.61H370.055V384.101Z",
    fill: "#F8F7F3"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask5_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.705H2041.3V-109.93H-39V847.705Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask5_75_11376)"
  }, _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M604.577 226.935L603.828 400.129",
    stroke: "#F8EC30",
    strokeWidth: 9.19816,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask6_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.706H2041.3V-109.929H-39V847.706Z",
    fill: "white"
  }))), /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask6_75_11376)"
  }, _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M134.194 172.633L133.844 436.417",
    stroke: "#F8EC30",
    strokeWidth: 19.7069,
    strokeLinejoin: "round"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask7_75_11376",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: -39,
    y: -110,
    width: 2081,
    height: 958
  }, _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M-39 847.705H2041.3V-109.93H-39V847.705Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask7_75_11376)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M433.614 365.908L154.527 281.505",
    stroke: "#F8EC30",
    strokeWidth: 5.90962,
    strokeLinejoin: "round",
    strokeDasharray: "8.95 8.95"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M154.794 290.849L140.387 277.223L159.923 273.869L154.794 290.849Z",
    fill: "#F8EC30"
  }))))))))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_75_11376"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 798,
    height: 602,
    fill: "white"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDesktop);
export default __webpack_public_path__ + "static/media/desktop.2c3789a1d240763c049fc92edb42b642.svg";
export { ForwardRef as ReactComponent };